import styled from 'styled-components';

export const Rating = styled.div.attrs({
  className: 'Rating',
  width: props => props.width,
  height: props => props.height,
  padding: props => props.padding,
  background: props => props.background
})`
  width: ${props => props.width};
  height: ${props => props.height};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => props.padding};
  background: ${props => props.background};
`;
